export const payrollOptions = {
  anticipatePaymentsOnWeekendsHolidays: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  hasMonthlyAdvance: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  advanceCalcBase: [
    { value: "1", label: "Salário base" },
    {
      value: "2",
      label:
        "Salário composto (Ex.: Periculosidade, Insalubridade, dentre outros que incorpora salário)",
    },
  ],
  advanceCalcBaseForCommissioned: [
    { value: "1", label: "Salário base" },
    { value: "2", label: "Salário base + Mínimo Garantido/comissões" },
    { value: "3", label: "Outro" },
  ],
  advancePaymentCalculationType: [
    { value: "1", label: "Proporcional" },
    { value: "2", label: "Integral" },
  ],
  newHiresReceiveAdvance: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  advanceAdhesionNextMonth: [
    { value: "1", label: "Compulsória" },
    { value: "2", label: "Original" },
  ],
  maternityLeaveReceiveAdvance: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  proLaboreReceiveAdvance: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  internReceiveAdvance: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  apprenticeReceiveAdvance: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  irrfAdvanceRetentionRule: [
    {
      value: "1",
      label:
        "Não, adiantamento e pagamento do saldo de salário até o último dia do próprio mês.",
    },
    {
      value: "2",
      label:
        "Sim, adiantamento de salários no dia 20 (exemplo) e pagamento do saldo de salários no 5º dia do mês seguinte, o valor do adiantamento deverá ser oferecido à tributação no dia 20.",
    },
    {
      value: "3",
      label:
        "Outro, descreva detalhadamente, caso os dados acima elencados não contemplem a regra de negócio da empresa e base legal",
    },
  ],
  advanceAnalyticalReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  advanceSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  advanceNetReport: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  advanceNetReportExcel: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
    { value: "3", label: "Consolidado (matriz|filial)" },
  ],
  thirteenthFirstInstallmentWriteOff: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não, baixa integral na 2ª Parcela" },
  ],
  vacationWriteOffMethod: [
    {
      value: "1",
      label: "Baixa total dos valores de férias no mês de início das férias",
    },
    {
      value: "2",
      label: "Realizar a baixa parcial em cada mês onde existe a férias",
    },
  ],
  resignationProvisionWhenTerminated: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  provisionAnalyticalReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  provisionSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  provisionNetReport: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  provisionNetReportExcel: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
    { value: "3", label: "Consolidado (matriz|filial)" },
  ],
  provisionAccountingSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  thirteenthAdvanceOnBirthday: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  thirteenthFirstInstallmentWithAverages: [
    { value: "2", label: "Não" },
    { value: "1", label: "Sim" },
    { value: "3", label: "Conforme CCT|ACT" },
    { value: "4", label: "Legislação Vigente" },
    { value: "5", label: "Outro" },
  ],
  internProLaboreThirteenth: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  internProLaboreThirteenthRubricsNovDec: [
    { value: "1", label: "Sim" },
    { value: "3", label: "Apenas em DEZ" },
    { value: "4", label: "Outro" },
  ],
  thirteenthAnalyticalReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  thirteenthSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  thirteenthNetReport: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  thirteenthNetReportExcel: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
    { value: "3", label: "Consolidado (matriz|filial)" },
  ],
  thirteenthAccountingSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  hasPlr: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  plrAccordingToCctAct: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  plrAnalyticalReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  plrSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  plrNetReport: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  plrNetReportExcel: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
    { value: "3", label: "Consolidado (matriz|filial)" },
  ],
  plrAccountingSyntheticReportOrder: [
    { value: "1", label: "Nome" },
    { value: "2", label: "Centro de Custo" },
    { value: "3", label: "Matrícula" },
    { value: "4", label: "Consolidado (matriz|filial)" },
  ],
  hasConsignedLoan: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
  ],
  consignedLoanDeductionLaw: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
    { value: "3", label: "Outro" },
  ],
  consignedLoanFullDeductionIfNoBalance: [
    { value: "1", label: "Sim" },
    { value: "2", label: "Não" },
    { value: "3", label: "Outro" },
  ],
  consignedLoanFormat: [
    { value: "1", label: "PDF" },
    { value: "2", label: "TXT" },
    { value: "3", label: "CSV" },
    { value: "4", label: "EXCEL" },
  ],
};
